import { EntityUtils } from '@record-it-npm/synchro-client';
import React, { ComponentProps, FunctionComponent } from 'react';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { PropsWithoutChildren } from 'record-it-components/utils/utilityTypes';
import { TimeTrackingActivityCompilation } from '../../../classes/entities/TimeTrackingActivityCompilation/timeTrackingActivityCompilationTypes';
import { TimeTrackingActivityCompilationListItem } from '../TimeTrackingActivityCompilationListItem/TimeTrackingActivityCompilationListItem';

export type TimeTrackingActivityCompilationListProps = PropsWithoutChildren<
  ComponentProps<'div'>
> & {
  timeTrackingActivityCompilations: Array<TimeTrackingActivityCompilation>;
};

export const TimeTrackingActivityCompilationList: FunctionComponent<TimeTrackingActivityCompilationListProps> =
  React.memo((props) => {
    const { timeTrackingActivityCompilations, ...remainingProps } =
      prepareProps({ props, ignoreChildren: true });

    return (
      <div {...remainingProps}>
        {timeTrackingActivityCompilations.map((compilation) => (
          <TimeTrackingActivityCompilationListItem
            key={EntityUtils.getTrackingKey(compilation)}
            timeTrackingActivityCompilation={compilation}
            data-testid="TimeTrackingActivityCompilationList.ListItem"
          ></TimeTrackingActivityCompilationListItem>
        ))}
      </div>
    );
  });
